import React from 'react';
import { Link } from 'react-router-dom';

// Cấu hình trạng thái Incoming cho các tab:
// Sau này khi hoàn thiện tab nào, bạn chỉ cần chuyển giá trị của tab đó thành `false`
// là nhãn "Incoming" sẽ tự động biến mất!
export const INCOMING_TABS = {
  'view-cockpit': false,     // Tab 01: Tổng quan Cockpit đã hoạt động
  'view-projects': true,    // Tab 02: Dự án Trọng điểm
  'view-approvals': true,   // Tab 05: Hàng đợi Phê duyệt
  'view-risks': true,       // Tab 06: Phụ thuộc & Rủi ro
  'view-dept-sales': true,  // Phòng Kinh Doanh / Sales
  'view-dept-mkt': true,    // Phòng Marketing
  'view-dept-proc': true,   // Phòng Thu Mua (Procure)
  'view-dept-log': true,    // Phòng Kho Vận (Logistics)
  'view-dept-hr': true,     // Phòng Hành Chính Nhân Sự
  'view-dept-acc': true,    // Phòng Kế Toán - Tài Chính
  'view-dept-rnd': true,    // Phòng Sản Phẩm / R&D
  'view-dept-assist': true, // Ban Trợ Lý
  'view-agents': true,      // Giám sát BOT & Skills
  'view-datasources': true, // CSDL chothuoc247 & RBAC
  'view-outputs': true,     // Kho Lưu Trữ Đầu Ra
  'view-audit': true,       // Audit Log & ROI Sim
};

// Mỗi role trưởng phòng (users.role) chỉ được vào đúng 1 view phòng ban của mình.
// role === 'admin' (hoặc không nằm trong map) => xem toàn bộ, không bị lọc.
export const ROLE_DEPARTMENT_VIEW = {
  kinh_doanh: 'view-dept-sales',
  marketing: 'view-dept-mkt',
  thu_mua: 'view-dept-proc',
  kho_van: 'view-dept-log',
  hcns: 'view-dept-hr',
  ke_toan: 'view-dept-acc',
  rnd: 'view-dept-rnd',
  tro_ly: 'view-dept-assist',
};

export default function DashboardSidebar({ activeView, onNavigate, onOpenModal, onShowToast, restrictedViewId }) {
  const isAct = (viewId) => (activeView === viewId ? 'nav-link active' : 'nav-link');
  const isRestricted = Boolean(restrictedViewId);

  const renderBadge = (viewId, defaultBadge = null) => {
    if (INCOMING_TABS[viewId]) {
      return <span className="nav-badge incoming">Incoming</span>;
    }
    return defaultBadge;
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="brand-logo-icon">
          <i className="fa-solid fa-brain-circuit"></i>
        </div>
        <div className="brand-name-wrap">
          <h2>TECHMEDCOM</h2>
          <span>AI Agentic Operating System</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {!isRestricted && (
          <>
            <div className="nav-category">Tầng Điều Hành Lãnh Đạo</div>
            <div className={isAct('view-cockpit')} id="nav-cockpit" onClick={() => onNavigate('view-cockpit')}>
              <i className="fa-solid fa-house"></i>
              <span>01. Tổng quan Cockpit</span>
              {renderBadge('view-cockpit')}
            </div>
            <div className={isAct('view-projects')} id="nav-projects" onClick={() => onNavigate('view-projects')}>
              <i className="fa-solid fa-cubes"></i>
              <span>02. Dự án Trọng điểm</span>
              {renderBadge('view-projects', <span className="nav-badge">4 PRJ</span>)}
            </div>
            <div className={isAct('view-approvals')} id="nav-approvals" onClick={() => onNavigate('view-approvals')}>
              <i className="fa-solid fa-signature"></i>
              <span>05. Hàng đợi Phê duyệt</span>
              {renderBadge('view-approvals', <span className="nav-badge danger">3 Chờ</span>)}
            </div>
            <div className={isAct('view-risks')} id="nav-risks" onClick={() => onNavigate('view-risks')}>
              <i className="fa-solid fa-triangle-exclamation"></i>
              <span>06. Phụ thuộc &amp; Rủi ro</span>
              {renderBadge('view-risks')}
            </div>
          </>
        )}

        <div className="nav-category">Dashboard Các Phòng Ban</div>
        {(!isRestricted || restrictedViewId === 'view-dept-sales') && (
          <div className={isAct('view-dept-sales')} id="nav-sales" onClick={() => onNavigate('view-dept-sales')}>
            <i className="fa-solid fa-chart-line" style={{ color: '#4ade80' }}></i>
            <span>Kinh Doanh / Sales</span>
            {renderBadge('view-dept-sales')}
          </div>
        )}
        {(!isRestricted || restrictedViewId === 'view-dept-mkt') && (
          <div className={isAct('view-dept-mkt')} id="nav-marketing" onClick={() => onNavigate('view-dept-mkt')}>
            <i className="fa-solid fa-bullhorn" style={{ color: '#c084fc' }}></i>
            <span>Marketing (Mẫu sâu)</span>
            {renderBadge('view-dept-mkt')}
          </div>
        )}
        {(!isRestricted || restrictedViewId === 'view-dept-proc') && (
          <div className={isAct('view-dept-proc')} id="nav-procurement" onClick={() => onNavigate('view-dept-proc')}>
            <i className="fa-solid fa-cart-shopping" style={{ color: '#fb923c' }}></i>
            <span>Thu Mua (Procure)</span>
            {renderBadge('view-dept-proc')}
          </div>
        )}
        {(!isRestricted || restrictedViewId === 'view-dept-log') && (
          <div className={isAct('view-dept-log')} id="nav-logistics" onClick={() => onNavigate('view-dept-log')}>
            <i className="fa-solid fa-warehouse" style={{ color: '#60a5fa' }}></i>
            <span>Kho Vận (Logistics)</span>
            {renderBadge('view-dept-log')}
          </div>
        )}
        {(!isRestricted || restrictedViewId === 'view-dept-hr') && (
          <div className={isAct('view-dept-hr')} id="nav-hr" onClick={() => onNavigate('view-dept-hr')}>
            <i className="fa-solid fa-users-gear" style={{ color: '#f472b6' }}></i>
            <span>Hành Chính Nhân Sự (HCNS)</span>
            {renderBadge('view-dept-hr')}
          </div>
        )}
        {(!isRestricted || restrictedViewId === 'view-dept-acc') && (
          <div className={isAct('view-dept-acc')} id="nav-accounting" onClick={() => onNavigate('view-dept-acc')}>
            <i className="fa-solid fa-calculator" style={{ color: '#34d399' }}></i>
            <span>Kế Toán - Tài Chính</span>
            {renderBadge('view-dept-acc')}
          </div>
        )}
        {(!isRestricted || restrictedViewId === 'view-dept-rnd') && (
          <div className={isAct('view-dept-rnd')} id="nav-rnd" onClick={() => onNavigate('view-dept-rnd')}>
            <i className="fa-solid fa-flask" style={{ color: '#fcd34d' }}></i>
            <span>Sản Phẩm / R&amp;D (Techpha)</span>
            {renderBadge('view-dept-rnd')}
          </div>
        )}
        {(!isRestricted || restrictedViewId === 'view-dept-assist') && (
          <div className={isAct('view-dept-assist')} id="nav-assist" onClick={() => onNavigate('view-dept-assist')}>
            <i className="fa-solid fa-user-tie" style={{ color: '#38bdf8' }}></i>
            <span>Ban Trợ Lý</span>
            {renderBadge('view-dept-assist')}
          </div>
        )}

        {!isRestricted && (
          <>
            <div className="nav-category">Hạ Tầng &amp; Truy Vết</div>
            <div className={isAct('view-agents')} id="nav-agents" onClick={() => onNavigate('view-agents')}>
              <i className="fa-solid fa-robot"></i>
              <span>Giám sát BOT &amp; Skills</span>
              {renderBadge('view-agents')}
            </div>
            <div className={isAct('view-datasources')} id="nav-datasources" onClick={() => onNavigate('view-datasources')}>
              <i className="fa-solid fa-database"></i>
              <span>CSDL chothuoc247 &amp; RBAC</span>
              {renderBadge('view-datasources')}
            </div>
            <div className={isAct('view-outputs')} id="nav-outputs" onClick={() => onNavigate('view-outputs')}>
              <i className="fa-solid fa-box-archive"></i>
              <span>Kho Lưu Trữ Đầu Ra</span>
              {renderBadge('view-outputs')}
            </div>
            <div className={isAct('view-audit')} id="nav-audit" onClick={() => onNavigate('view-audit')}>
              <i className="fa-solid fa-clock-rotate-left"></i>
              <span>Audit Log &amp; ROI Sim</span>
              {renderBadge('view-audit')}
            </div>
          </>
        )}
      </nav>

      {/* Quick Actions */}
      <div className="quick-action-section">
        <Link to="/admin/jobs" className="btn-back-admin-sidebar" title="Quay lại giao diện quản trị">
          <i className="fa-solid fa-arrow-left"></i> Về trang quản trị
        </Link>
        <button className="btn-quick primary" onClick={() => onOpenModal('modal-task')} type="button">
          <i className="fa-solid fa-plus"></i> Giao task cho AI Agent
        </button>
        <button className="btn-quick" onClick={() => onShowToast('Đang kết nối OpenClaw 9Router...')} type="button">
          <i className="fa-solid fa-bolt"></i> Đồng bộ CSDL chothuoc247
        </button>
      </div>

      <div className="sidebar-footer-info">
        <span>Techmedcom AI OS</span>
        <span style={{ color: 'var(--green)', fontWeight: '700' }}>● Online</span>
      </div>
    </aside>
  );
}
